import { useRef, type RefObject } from 'react';

const useFocus = <T extends HTMLElement>(): [RefObject<T>, () => void] => {
  const htmlElRef = useRef<T>(null);
  const setFocus = (): void => {
    if (htmlElRef.current) {
      const obj = htmlElRef.current;
      obj.focus();
    }
  };

  return [ htmlElRef, setFocus ];
}

export default useFocus;
